import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../images/avatar';
import { HStack } from '../layouts/stack.layout';

const linkingContainerStyles = {
  container:
    'w-full items-center cursor-pointer hover:bg-white/[5%] px-3 rounded-md py-2',
};

type LinkingContainerProps = {
  onClick?: Function;
  path: string;
  image: { alt: string; url: string };
  children: ReactNode;
};

export default function LinkingContainer(props: LinkingContainerProps) {
  return (
    <Link
      onClick={() => props.onClick && props.onClick()}
      to={props.path}
      className="w-full"
    >
      <HStack gap="base" extensions={linkingContainerStyles.container}>
        <Avatar size="2xs" url={props.image.url} alt={props.image.alt} />
        {props.children}
      </HStack>
    </Link>
  );
}
